import React, { useState, useEffect } from "react";
import { FormattedHTMLMessage, useIntl } from "gatsby-plugin-intl";
import ModalPopup from "../modal";
import "./earthquakeNoticeModal.scss";

const EarthquakeNoticeModal = () => {
  const [showModal, setShowModal] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    if (process.env.GATSBY_BRAND !== 'oprotect') {
      setShowModal(true);
    }
  }, []);

  const handleClose = () => {
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <ModalPopup
      show={showModal}
      onClose={handleClose}
      heading={intl.formatMessage({ id: "earthquakeModalTitle" })}
      size="lg"
    >
      <hr className="earthquake-modal-divider" />
      <div className="earthquake-notice-content">
        <FormattedHTMLMessage id="earthquakeModalContent" />
      </div>
    </ModalPopup>
  );
};

export default EarthquakeNoticeModal;
